import * as React from "react"
import Svg, { Path, Rect } from "react-native-svg"
import type { SvgProps } from "react-native-svg"

function SvgComponent(props: SvgProps) {
    return (
        <Svg
            width={28}
            height={28}
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <Path
                d="M4.26 15.643c-1.12-1.65-1.51-3.6-1.102-5.486.408-1.885 1.59-3.574 3.321-4.751 1.732-1.177 3.895-1.76 6.083-1.64 2.188.12 4.252.934 5.802 2.29 1.55 1.357 2.482 3.162 2.618 5.077.137 1.915-.53 3.808-1.874 5.323-1.345 1.515-3.276 2.548-5.43 2.906-2.155.358-4.384.015-6.27-.964h0l-3.11.777a.853.853 0 01-.394.005.782.782 0 01-.342-.172.642.642 0 01-.196-.3.577.577 0 01.005-.344l.889-2.721h0z"
                stroke="#9490B1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Rect x={7} y={9} width={10} height={1} rx={0.5} fill="#9490B1" />
            <Rect x={7} y={13} width={10} height={1} rx={0.5} fill="#9490B1" />
        </Svg>
    )
}

export default SvgComponent
